import ScrollIndicator from "@quarkly/community-kit/ScrollIndicator";
export default ScrollIndicator;